import { useCircleSize, Overlap, Box, Circle } from "arkh";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "react-native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { TodoTagButtonContentActive_todoCategoryTag$key } from "./__generated__/TodoTagButtonContentActive_todoCategoryTag.graphql";

export function TodoTagButtonInactiveContent() {
  return (
    <FormattedMessage
      defaultMessage="Tags"
      description="Todo Toolbar Button Tags Title"
    />
  );
}
export function TodoTagButtonActiveContent(props: {
  tags: TodoTagButtonContentActive_todoCategoryTag$key;
}) {
  const size = useCircleSize("badge");
  const tags = useFragment(
    graphql`
      fragment TodoTagButtonContentActive_todoCategoryTag on TodoCategoryTag
      @relay(plural: true) {
        id
        title
        color
      }
    `,
    props.tags
  );

  return (
    <>
      {tags.length > 3 ? (
        <>
          <Overlap
            maxNumberOfItems={8}
            render={(t) => <TagDot color={t.color} />}
            data={tags}
            viewWidth={size}
            overlapRatio={0.33}
          />

          <Box spaceLeft="small">
            <Text>
              <FormattedMessage
                defaultMessage="{count} tags"
                description="Todo Toolbar Button Tags Title"
                values={{
                  count: tags.length,
                }}
              />
            </Text>
          </Box>
        </>
      ) : (
        <Box style={{ flexDirection: "row", alignItems: "center" }} gap="small">
          {tags.map((tag) => (
            <TagItem key={tag.id} title={tag.title} color={tag.color} />
          ))}
        </Box>
      )}
    </>
  );
}

function TagItem(props: { title: string; color: string }) {
  const size = useCircleSize("smallMedium");

  return (
    <Box
      style={{
        height: size,
        alignItems: "center",
        borderRadius: size / 2,
        flexDirection: "row",
      }}
      gap="xsmall"
    >
      <TagDot color={props.color} />
      <Text>{props.title}</Text>
    </Box>
  );
}
function TagDot(props: { color: string; opacity?: number }) {
  return (
    <Circle
      size="badge"
      style={{
        backgroundColor: props.color,
        borderWidth: 1,
        borderColor: "#FFF",
        opacity: props.opacity ?? 1,
      }}
    />
  );
}
